// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"bf9b0b2b","117":"f2d527a5","171":"64ae7f3d","209":"e1f55257","478":"a10d4175","625":"609ddc96","745":"dd1a250d","922":"a9748d02","964":"f813fc8a"}[chunkId] + ".chunk.js";
};